var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content text text--blue"},[_vm._v("Sie haben sich für den Newsletter angemeldet.")]),_c('my-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }